<script>
    import {QSelect} from 'quasar-framework'

    var mixins = [{
        props: QSelect.props
    }]
    QSelect.mixins.forEach(m => {
        mixins.push({
            props: m.props
        })
    })

    const all = '[ALL]'

    export default {
        name: 'SelectExtended',

        mixins,

        props: {
            selectAll: Boolean,
        },
        data() {
            let value = this.value
            if (this.multiple) {
                if (this.selectAll && value && value.length == this.options.length)
                    value.push(all)
            }
            return {
                inputValue: value,
                oldValue: value,
            }
        },
        watch: {
            value(newValue) {
                if (this.selectAll && this.multiple && newValue && newValue.length == this.computedOptions.length - 1)
                    this.oldValue = this.inputValue = newValue.concat([all])
                else
                    this.oldValue = this.inputValue = newValue
            }
        },
        components: {
            QSelect
        },
        computed: {
            computedOptions() {
                let options = this.options
                if (this.selectAll && this.multiple && options.length > 1)
                    options = [{value: '[ALL]', label: this.$T('select all')}].concat(options)
                return options
            }
        },
        methods: {
            onInput(newValue) {
                if (this.selectAll && this.multiple) {
                    let option = newValue.filter(o => !this.oldValue.includes(o))
                        .concat(this.oldValue.filter(o => !newValue.includes(o)))[0]
                    let adding = newValue.length - this.oldValue.length == 1
                    let removing = !adding
                    if (option == all && adding)
                        this.inputValue = this.computedOptions.map(o => o.value)
                    else if (option == all && removing)
                        this.inputValue = []
                    else if (option != all && removing && newValue.includes(all))
                        this.inputValue = newValue.filter(o => o != all)
                    else
                        this.inputValue = newValue
                    this.oldValue = this.inputValue

                    this.$emit('input', this.inputValue.filter(o => o != all))
                } else {
                    this.inputValue = newValue
                    this.$emit('input', this.inputValue)
                }
            }
        },
        render(h) {
            return h(QSelect, {
                props: {
                    ...this.$props,
                    value: this.inputValue,
                    options: this.computedOptions
                },
                attrs: this.$attrs,
                on: {
                    input: v => this.onInput(v)
                }
            }, [
                this.$slots.default
            ])
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/SelectExtended.vue